import { H3 } from 'platform-components/common';
import { HEADER_TEXT_SIZE, TEXT_WEIGHT } from 'platform-components/constants';
import React from 'react';

export const CalendarPlanShowcaseTitle = () => {
    return <H3 fixed id="calendarPlan.header" size={HEADER_TEXT_SIZE.L} weight={TEXT_WEIGHT.M} />;
};
